const getRecentSearchTerms = () => {
    try {
        const jsonValue = localStorage.getItem('searchTerms');
        return jsonValue !== null ? JSON.parse(jsonValue) : [];
    }
    catch (e) {
        alert("An unknown error occurred.");
        console.log(e.message);
    }
}

const setRecentSearchTerms = (array) => {
    try {
        localStorage.setItem('searchTerms', array);
    }
    catch (e) {
        alert("An unknown error occurred.");
        console.log(e.message);
    }
}

export { getRecentSearchTerms, setRecentSearchTerms };